import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="action-text"
//
// Reveals the editor toolbar, which stays collapsed until the hammer icon is
// clicked. Matches either editor's toolbar element so the pattern keeps working
// while Trix remains available as a fallback.
//
// The toggle is icon-only, so the views give it an aria-label and an initial
// aria-expanded="false"; this controller keeps aria-expanded true to the toolbar and
// points aria-controls at it. Wired lazily rather than on connect, because the editor
// builds its toolbar during its own initialisation, which can land after connect.
export default class extends Controller {
  static targets = ['toggle']

  toggle () {
    const toolbar = this.toolbarElement
    if (!toolbar) return

    const open = toolbar.classList.toggle('toolbar-open')
    if (!this.hasToggleTarget) return

    toolbar.id ||= `toolbar-${Math.random().toString(36).slice(2)}`
    this.toggleTarget.setAttribute('aria-controls', toolbar.id)
    this.toggleTarget.setAttribute('aria-expanded', open)
  }

  get toolbarElement () {
    return this.element.querySelector('lexxy-toolbar, trix-toolbar')
  }
}
